import heroImage from "../assets/condominium/s1_2.jpg";

import locationImage from "../assets/condominium/s2_3.png";

import infrastructureImage1 from "../assets/condominium/s3_4.png";
import infrastructureImage2 from "../assets/condominium/s3_5.png";
import infrastructureImage3 from "../assets/condominium/s3_6.png";

import galleryImage1 from "../assets/condominium/s3_7.jpg";
import galleryImage2 from "../assets/condominium/s3_8.jpg";
import galleryImage3 from "../assets/condominium/s3_9.png";
import galleryImage4 from "../assets/condominium/s4_7.png";
import galleryImage5 from "../assets/condominium/s4_8.png";
import galleryImage6 from "../assets/condominium/s4_9.jpg";
import plantImage1 from "../assets/condominium/planta-ponta.avif";
import plantImage2 from "../assets/condominium/planta-meio.avif";

const condominiumImages = {
  hero: heroImage,

  location: [locationImage],

  infrastructure: [
    infrastructureImage1,
    infrastructureImage2,
    infrastructureImage3,
  ],

  plants: [plantImage1, plantImage2],

  units: [],

  gallery: [
    galleryImage1,
    galleryImage2,
    galleryImage3,
    galleryImage4,
    galleryImage5,
    galleryImage6,
  ],
};

export default condominiumImages;
